import PropTypes from 'prop-types';

import Charges from './Charges';
import Offer from './Offer';

export default {
  roomTypeId: PropTypes.string,
  charges: PropTypes.shape(Charges),
  hotelOffer: PropTypes.shape(Offer),
};
